import { SkeletonBlock, SkeletonCard, SkeletonContentWrapper, SkeletonHeader, SkeletonHeaderLine, SkeletonHeaderLogo, SkeletonPage } from './styles';

const CARD_COUNT = 6;

/**
 * Skeleton that reserves space for menu content to reduce CLS
 * when products load and to improve perceived LCP.
 */
export const MenuContentSkeleton = () => (
  <SkeletonContentWrapper>
    {Array.from({ length: CARD_COUNT }).map((_, i) => (
      <SkeletonCard key={i}>
        <div>
          <SkeletonBlock height="18px" width="70%" />
          <SkeletonBlock height="12px" width="90%" />
          <SkeletonBlock height="20px" width="40%" />
        </div>
        <SkeletonBlock height="80px" width="80px" />
      </SkeletonCard>
    ))}
  </SkeletonContentWrapper>
);

/** Full-page placeholder used before the menu chunk and boot data arrive, so there is a single loading state. */
export const MenuPageSkeleton = () => (
  <SkeletonPage aria-busy="true">
    <main>
      <SkeletonHeader>
        <SkeletonHeaderLogo />
        <div style={{ flex: 1 }}>
          <SkeletonHeaderLine width="60%" height="22px" />
          <SkeletonHeaderLine width="30%" height="14px" />
        </div>
      </SkeletonHeader>
      <MenuContentSkeleton />
    </main>
  </SkeletonPage>
);
